document.addEventListener("DOMContentLoaded", () => {
    const tabButtons = document.querySelectorAll(".tab-button");
    const sections = Array.from(
        document.querySelectorAll(".featured-collection-section")
    );

    function hideAllSections() {
        sections.forEach((section) => {
            section.style.display = "none";
        });
    }

    function showSection(targetSection) {
        targetSection.style.display = "block";
    }

    function removeActiveClass() {
        tabButtons.forEach((button) => button.classList.remove("active"));
    }

    function scrollToTabs() {
        const tabsContainer = document.querySelector(".scrollable-tabs-container");
        if (tabsContainer) {
            setTimeout(() => {
                tabsContainer.scrollIntoView({
                    behavior: "smooth",
                    block: "start",
                });
            }, 300);
        }
    }

    function updatePLPBanner(collectionAttr) {
        const allBannerImages = document.querySelectorAll(".plp-banner-image");
        allBannerImages.forEach((img) => {
            img.style.display =
                img.getAttribute("data-collection") === collectionAttr
                    ? "block"
                    : "none";
        });
    }

    function activateTab(collectionAttr, shouldScroll = true) {
        removeActiveClass();
        hideAllSections();
        const button = Array.from(tabButtons).find(
            (button) => button.getAttribute("data-collection") === collectionAttr
        );
        const targetSection = sections.find((section) =>
            section.querySelector(
                '.pdp-featured-collection[data-collection="' + collectionAttr + '"]'
            )
        );
        if (button && targetSection) {
            button.classList.add("active");
            showSection(targetSection);
            updatePLPBanner(collectionAttr);
            if (shouldScroll && window.innerWidth > 991) {
                setTimeout(scrollToTabs, 100);
            }
        }

        const event = new CustomEvent("tabChanged", {
            detail: {
                collection: collectionAttr,
            },
        });

        document.dispatchEvent(event);
    }

    const urlParams = new URLSearchParams(window.location.search);
    const flag = urlParams.get("flag");

    if (flag) {
        setTimeout(() => {
            activateTab(flag, true);
        }, 100);
    }

    tabButtons.forEach((button) => {
        button.addEventListener("click", function () {
            const collectionAttr = this.getAttribute("data-collection");
            activateTab(collectionAttr, false);

            const newUrl = new URL(window.location);
            newUrl.searchParams.set("flag", collectionAttr);
            window.history.replaceState(null, "", newUrl);
        });
    });

    if (!flag) {
        hideAllSections();
        const initialActiveTab = document.querySelector(".tab-button.active");
        if (initialActiveTab) {
            const initialCollectionAttr =
                initialActiveTab.getAttribute("data-collection");
            const initialTargetSection = sections.find((section) =>
                section.querySelector(
                    '.pdp-featured-collection[data-collection="' +
                    initialCollectionAttr +
                    '"]'
                )
            );
            if (initialTargetSection) {
                showSection(initialTargetSection);
            }
        }
    }

    window.addEventListener("popstate", function () {
        const currentParams = new URLSearchParams(window.location.search);
        const currentFlag = currentParams.get("flag");
        if (currentFlag) {
            activateTab(currentFlag, true);
        }
    });
});
